//@ts-nocheck
import { getAccount } from "utils/sessionHelper";
import { useSession } from "next-auth/react";
import { useEffect } from "react";
export const events = {
  // we noticed that the event 'identify' provides a lot of data to Rudderstack, so we decided to disable it
  // the user_id generated does not provide enough value to justify the amount of data sent
  // we will add 'lempire_user_id' to the event 'track' instead (since user_id is a reserved property in the event 'track')
  // identify: {
  //   dev: { status: false, start: '*', end: '*', integrations: { All: false, BigQuery: true } },
  //   production: { status: false, start: '*', end: '*', integrations: { All: false } },
  // },
  sign_up_taplio: {
    dev: { status: true, start: '*', end: '*', integrations: { All: false, BigQuery: true } },
    production: { status: true, start: '*', end: '*', integrations: { All: false, BigQuery: true } },
  },
  //remove if not needed -manoj
  // @notes we are using the events configuration to dispatch dynamically groups to integrations
  // in the exact same way
  // currents groups are: user, team
  // @todo put back false on staging.integrations.Mixpanel after data has been validated, then activate production status
  // user: {
  //   dev: { status: true, start: '*', end: '*', integrations: { All: false, BigQuery: true } },
  //   production: { status: false, start: '*', end: '*', integrations: { All: false, BigQuery: true, Mixpanel: true } },
  // },
  // team: {
  //   dev: { status: true, start: '*', end: '*', integrations: { All: false, BigQuery: true } },
  //   production: { status: false, start: '*', end: '*', integrations: { All: false, BigQuery: true, Mixpanel: true } },
  // },
};



// @notes default values for groups
// used for creation of groups in the event 'group'
//remove if not needed -manoj
export const groups = {
  // org: {
  //   lemcal_billing_status: 'not_paying',
  //   lemcal_licenses_count: 0,
  //   lemcal_licenses_used_count: 0,
  //   lemcal_plan: 'unset',
  //   lemlist_billing_status: 'not_paying',
  //   lemlist_licenses_count: 0,
  //   lemlist_licenses_used_count: 0,
  //   lemlist_plan: 'unset',
  //   lemwarm_billing_status: 'not_paying',
  //   lemwarm_plan: 'unset',
  //   lemwarm_licenses_count: 0,
  //   lemwarm_licenses_used_count: 0,
  //   feature_flags: [],
  //   users_count: 1,
  // },
  user: {
    team_id: undefined,
    crm_hubspot_state: 'unset',
    crm_pipedrive_state: 'unset',
    crm_salesforce_state: 'unset',
    chrome_extension_state: 'unset',
    sign_up_date: undefined,
    $email: '-',
    $first_name: undefined,
    $name: undefined,
    $city: undefined,
    $country_code: undefined,
    $timezone: undefined,
    feature_flags: [],
    job_title: undefined,
    companySize: undefined,
    job_sales: undefined,
    job_role: undefined,
  },
};

export const getRudder = async (api, env) => {
  const _rudder = {
    api,
    check: (event) => {
      try {
        if (events[event] && events[event][env]) {

          const { status, start, end, integrations } = events[event][env];
          if (status &&
            ((start === '*' && end === '*') ||
              Interval.fromDateTimes(DateTime.fromISO(start), DateTime.fromISO(end)).contains(DateTime.local()))) {
            return { integrations };
          }
        }
        return undefined;
      } catch (err) {
        console.log('rudderstack.check: error', { err });
        return undefined;
      }
    },
    track: async (event, properties = {}) => {
      const integrations = _rudder.check(event);
      // console.log('check integrations', integrations);
      if (Boolean(integrations) === true && Object.keys(integrations).length > 0) {
        try {


          // console.log(properties, 'checking things...')
          const additional = {
            lempire_user_id: properties?.id || "",
            team_id: properties?.subscription?.org || "",
            product: "Taplio - NextJS",
            stripe_customer_id: properties?.subscription?.customer || ""
          };

          delete properties?.subscription;
          // console.log({ ...properties, ...additional }, _rudder.api.track, 'check props rudder');
          _rudder.api.track(event, { ...properties, ...additional }, integrations);

        } catch (err) {
          console.log('rudderstack.track: error', { event, properties, err });
        }
      }
    },
  };

  return _rudder;
};

export const trackWithRudder = async (api, user, event = 'sign_up_taplio', callType = 'track', env) => {
  env = (env) ? "dev" : "production";
  const r = await getRudder(api, env);
  r[callType](event, user);
}


